import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=14e980ab&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=14e980ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e980ab",
  null
  
)

export default component.exports